// heading & body

export type TypographyLineHeight = "small" | "large";

// heading

type TypographyHeadingElement = "h1" | "h2" | "h3" | "h4" | "h5";

export type TypographyHeadingFontSize =
  | "18px"
  | "20px"
  | "24px"
  | "32px"
  | "40px"
  | "48px";

type TypographyHeadingElementAndFontSize = {
  component: TypographyHeadingElement;
  fontSize: TypographyHeadingFontSize;
};

export type TypographyHeadingLevel = "1" | "2" | "3" | "4" | "5";

export const typographyHeadingLevelMap: {
  [key in TypographyHeadingLevel]: TypographyHeadingElementAndFontSize;
} = {
  "1": {
    component: "h1",
    fontSize: "48px"
  },
  "2": {
    component: "h2",
    fontSize: "32px"
  },
  "3": {
    component: "h3",
    fontSize: "24px"
  },
  "4": {
    component: "h4",
    fontSize: "20px"
  },
  "5": {
    component: "h5",
    fontSize: "18px"
  }
};

export const typographyHeadingLevelMobileAndTabletMap: {
  [key in Extract<
    TypographyHeadingLevel,
    "1"
  >]: TypographyHeadingElementAndFontSize;
} = {
  "1": {
    component: "h1",
    fontSize: "40px"
  }
};

export type TypographyHeadingLineHeight = "100%" | "120%";

export const headingLineHeightMap: {
  [key in TypographyLineHeight]: { lineHeight: TypographyHeadingLineHeight };
} = {
  small: {
    lineHeight: "100%"
  },
  large: {
    lineHeight: "120%"
  }
};

// body

export type TypographyBodyFontSize = "12px" | "14px" | "16px";

export type TypographyBodySize = "xsmall" | "small" | "medium";

export const typographyBodySizeMap: {
  [key in TypographyBodySize]: { fontSize: TypographyBodyFontSize };
} = {
  xsmall: {
    fontSize: "12px"
  },
  small: {
    fontSize: "14px"
  },
  medium: {
    fontSize: "16px"
  }
};

export type TypographyBodyLineHeight = "120%" | "140%";

export const typographyBodyLineHeightMap: {
  [key in TypographyLineHeight]: { lineHeight: TypographyBodyLineHeight };
} = {
  small: {
    lineHeight: "120%"
  },
  large: {
    lineHeight: "140%"
  }
};
